module.exports = __webpack_public_path__ + "img/chat.3b10100b.png";